import { getLocale } from "../runtime";

const sv_user = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Användare`
};

const user = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_user(inputs)
	return "user";
};

export { user as "user" };